// extracted by mini-css-extract-plugin
module.exports = {"tabsPrimaryCard":"antd-pro-ui-tabs-index-tabsPrimaryCard","topPosition":"antd-pro-ui-tabs-index-topPosition"};